import { useField } from 'formik';
import XMultiSelect from './XMultiSelect';

const XMultiSelectWrapper = ({ name, ...props }) => {
    const [field, meta, helpers] = useField(name);

    return (
        <XMultiSelect
            {...props}
            selectedValues={field.value || []}
            onChange={(newValues) => helpers.setValue(newValues)}
            isForm={true}
        />
    );
};

export default XMultiSelectWrapper;